import logo from './logo.svg';
import './App.css';
import AppRouter from './router/Router';
import 'bootstrap/dist/css/bootstrap.min.css';


function App() {
  return <AppRouter />;
}

export default App;
